import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";

const FlipCardContainer = styled.div`
  flex: 0 0 30%;
  background-color: transparent;
  perspective: 1000px;
  min-height: 120px;
  min-width: max-content;

  &:hover .flip-card-inner {
    transform: rotateY(180deg) translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  @media only screen and (max-width: 720px) {
    flex: 0 0 45%;
  }

  @media only screen and (max-width: 540px) {
    flex: 0 0 100%;
  }
`;

const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: all .75s;
  transform-style: preserve-3d;
`;

const FlipCardFace = styled.div`
  background-color: var(--cor-2);
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &.flip-card-front,
  &.flip-card-back {
    border-radius: 5px;

    p {
      color: var(--cor-txt-2);
    }
  }

  &.flip-card-front {
    background-color: var(--cor-2);
    
    i {
      color: var(--cor-txt-2);
    }
  }

  &.flip-card-back {
    background-color: var(--cor-2);
    transform: rotateY(180deg);

    p {
      font-size: 16px;
      margin: 0;
      padding: 20px; /* Adicionando padding ao texto */
    }
  }

  .box-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;

    i {
      font-size: 2rem;
    }
  }

  p {
    font-size: 23px;
    margin: 0;
    font-weight: 500;
  }
`;


const BoxCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  gap: 1.5rem;

  .card {
    max-width: 33%;
    min-width: 300px;
    min-height: 250px;
    padding: 1rem;
  }
`;

export { BoxCards };

const FlipCard = ({ to, frontContent, backContent }) => {
  return (
    <FlipCardContainer>
      <Link to={to}>
        <FlipCardInner className="flip-card-inner">
          <FlipCardFace className="flip-card-front">
            <div className="box-icon">
              {frontContent.icon && <i className={frontContent.icon} />}
            </div>
            <p>{frontContent.text}</p>
          </FlipCardFace>
          <FlipCardFace className="flip-card-back">
            <p>{backContent}</p>
          </FlipCardFace>
        </FlipCardInner>
      </Link>
    </FlipCardContainer>
  );
};

export default FlipCard;
